// 侧边导航
<template>
  <div class="side-nav-container">
    <ul class="side-list">
      <li
        v-for="(serive, sIndex) in rightQQ"
        :key="sIndex + '-serive'"
        class="serive-item"
        @click="toKF(serive)"
      >
        <div class="serive-icon bg-serive"></div>
        <div class="serive-name">
          {{ serive.pcsId === userId ? '进入坐席' : serive.pcsNickname }}
        </div>
      </li>
      <li
        v-for="(floor, fIndex) in floorList"
        :key="fIndex + '-floor'"
        :class="[
          'floor-item-nav',
          floorIndex === fIndex + 1 ? 'active-red' : '',
        ]"
        @click="handleFloor(fIndex)"
      >
        <div class="floor-title">
          {{ floor.pcName }}
        </div>
      </li>

      <!-- <li class="serive-item" @mouseenter="showQrcode" @mouseleave="hideQrcode">
        <div class="serive-icon bg-qrcode"></div>
        <div class="serive-name">咨询</div>
      </li> -->
      <li class="serive-item bottom-line">
        <div class="serive-icon bg-qrcode"></div>
        <div class="serive-name">在线客服</div>
        <div class="qrcode-box kefu-qrcode">
          <div class="qrcode-img">
            <img src="../imgs/wx-kefu.jpg" alt="" />
          </div>
          <div class="qrcode-title">
            <p>微信扫一扫</p>
          </div>
          <div class="qrcode-img">
            <img :src="qrcode" alt="" />
          </div>
          <div class="qrcode-title">
            <p>QQ扫一扫</p>
          </div>
        </div>
      </li>
      <li class="serive-item bottom-line">
        <div class="serive-icon bg-phone"></div>
        <div class="serive-name">客服热线</div>
        <div class="hot-phone">
          <div class="phone">
            <img src="../imgs/hot-phone.png" alt="" />
          </div>
          <div class="tel-num">
            <p>欢迎来电咨询</p>
            <p>021-31579633</p>
          </div>
        </div>
      </li>
      <li
        class="serive-item qrcode-card"
        @mouseenter="showQrcode"
        @mouseleave="hideQrcode"
      >
        <div class="serive-icon bg-official"></div>
        <div class="serive-official">公众号</div>
        <div class="qrcode-box">
          <div class="qrcode-img">
            <img :src="qrcode" alt="" />
          </div>
          <div class="qrcode-title">
            <p>微信扫一扫</p>
            <p>关注西兰蒂亚公众号</p>
          </div>
        </div>
      </li>
      <li class="serive-top" @click="backTop">
        <div class="top">
          <i class="el-icon-arrow-up"></i>
        </div>
        <div class="nav-title">顶部</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 客服
      rightQQ: [],
      qrcode: require('../../../assets/images/homePage/wx_offical_account.jpg'),
      isShowQrcode: false,
      userId: '',
      floorIndex: 1,
      floorList: [
        // 右侧楼层数据
        {
          id: '1-floor',
          pcNo: 'demandHall',
          pcName: '需求大厅',
        },
        {
          id: '2-floor',
          pcNo: 'entDirectory',
          pcName: '企业名录',
        },
        {
          id: '3-floor',
          pcNo: 'entServer',
          pcName: '智筑服务',
        },
        {
          id: '4-floor',
          pcNo: 'partner',
          pcName: '合作伙伴',
        },
      ],
    }
  },

  mounted() {
    this.seriveIcon = this.seriveStaticIcon
    this.handleScroll()
  },
  methods: {
    // 获取右侧侧边栏
    async getRightSidebar() {
      let { data } = await this.$http.get('/cms/ptChannels/querySidebar')
      this.rightQQ = data.ptCustomerServiceList
      this.userId = window.localStorage.getItem('id')
    },
    // 点击客服
    toKF(serive) {
      if (serive.pcsId === this.userId) {
        this.$emit('toKF', [serive, '进入坐席'])
      } else {
        this.$emit('toKF', [serive, ''])
      }
    },
    showQrcode() {
      this.isShowQrcode = true
    },
    hideQrcode() {
      this.isShowQrcode = false
    },
    // 返回顶部
    backTop() {
      const i = document.body.scrollHeight / 100
      // 参数i表示间隔的幅度大小，以此来控制速度,
      document.documentElement.scrollTop -= i
      let c = null
      if (document.documentElement.scrollTop > 0) {
        c = setTimeout(() => this.backTop(i), 5)
      } else {
        clearTimeout(c)
      }
    },
    // 监听滚动
    handleScroll() {
      let _this = this
      window.onscroll = function () {
        const window_scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let floor_item = document.getElementsByClassName('floor-item')
        if (floor_item.length > 0) {
          for (let i = 0, len = floor_item.length; i < len; i++) {
            const floor_offsetTop = floor_item[i].offsetTop - 300
            if (window_scrollTop >= floor_offsetTop) {
              _this.floorIndex = i + 1
            }
          }
        }
      }
    },
    // 点击右侧侧边栏进行定位
    handleFloor(index) {
      var _this = this
      let floor_item = document.getElementsByClassName('floor-item')
      let floor_offsetTop = floor_item[index].offsetTop
      console.log(floor_offsetTop)
      let window_scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 判断浏览器
      let userAgent = navigator.userAgent
      console.log(userAgent)
      let timer = null
      if (userAgent.indexOf('Chrome') > -1) {
        // 谷歌
        timer = {
          step: 10,
          times: 1,
          FLOOR_OFFSETTOP: floor_offsetTop,
        }
      } else {
        timer = {
          step: 30,
          times: 1,
          FLOOR_OFFSETTOP: floor_offsetTop,
        }
      }

      if (window_scrollTop > floor_offsetTop) {
        _this.setFloorScrollArrowUp(timer)
      } else if (window_scrollTop === floor_offsetTop) {
        return false
      } else {
        _this.setFloorScrollArrowDown(timer)
      }
    },
    /**
     * 设置楼层向上滚动
     * @params Object timer 定时器配置
     */
    setFloorScrollArrowUp(timer) {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        const window_scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        if (window_scrollTop <= timer.FLOOR_OFFSETTOP) {
          document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP
          document.body.scrollTop = timer.FLOOR_OFFSETTOP
          clearInterval(this.timer)
        } else {
          document.documentElement.scrollTop = window_scrollTop - timer.step
          document.body.scrollTop = window_scrollTop - timer.step
        }
      }, timer.times)
    },

    /**
     * 设置楼层向下滚动
     * @params Object timer 定时器配置
     */
    setFloorScrollArrowDown(timer) {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        const window_scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop

        if (window_scrollTop >= timer.FLOOR_OFFSETTOP) {
          document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP
          document.body.scrollTop = timer.FLOOR_OFFSETTOP
          clearInterval(this.timer)
        } else {
          if (window_scrollTop === 2209) {
            clearInterval(this.timer)
            return false
          }
          document.documentElement.scrollTop = window_scrollTop + timer.step
          document.body.scrollTop = window_scrollTop + timer.step
        }
      }, timer.times)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-nav-container {
  width: 100%;
  position: relative;

  ul.side-list {
    width: 66px;
    li.serive-item {
      width: 100%;
      padding: 13px 0;
      // border-bottom: 1px solid #f3f3f3;
      color: #333333;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      transition: background 0.1s ease-out;
      font-size: 8px;
      font-weight: bold;
      color: #333333;
      line-height: 11px;
      position: relative;
      .serive-icon {
        width: 24px;
        height: 24px;
        background-size: contain;
        background-repeat: no-repeat;
        margin-bottom: 6px;
      }
      .bg-serive {
        background-image: url('../../../assets/images/homePage/sidebar/service.png');
      }
      .bg-top {
        background-image: url('../../../assets/images/homePage/sidebar/top.png');
      }
      .bg-qrcode {
        background-image: url('../imgs/bg-qrcode.png');
      }
      .bg-phone {
        background-image: url('../imgs/bg-phone.png');
      }
      .bg-official {
        background-image: url('../imgs/setting.png');
      }
      .serive-official {
        width: 100%;
        text-align: center;
      }
      .serive-name {
        text-align: center;
        overflow: hidden;
        line-height: 18px;
        overflow: hidden;
        letter-spacing: 1px;
        padding-left: 0.5px;
      }
      .qrcode-box {
        display: none;
        position: absolute;
        left: -132px;
        bottom: -10px;
        width: 126px;
        height: 156px;
        background-color: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.35);
        // display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .qrcode-img {
          width: 100px;
          height: 100px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
        .qrcode-title {
          p {
            font-size: 8px;
            color: #333333;
            line-height: 11px;
            text-align: center;
            &:first-child {
              margin: 7px 0 7px;
            }
          }
        }
      }
      .hot-phone {
        position: absolute;
        bottom: 0;
        left: -132px;
        width: 126px;
        height: 106px;
        background: #ffffff;
        display: none;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        .phone {
          width: 40px;
          height: 40px;
          img {
            width: 100%;
            height: auto;
          }
        }
        .tel-num {
          right: 0;
          bottom: 0;
          text-align: center;
          p:first-child {
            font-size: 8px;
            color: #333333;
            line-height: 11px;
            margin: 6px 0;
          }
          p:last-child {
            font-size: 13px;
            font-weight: bold;
            color: #ce2939;
            line-height: 18px;
          }
        }
      }

      .kefu-qrcode {
        bottom: -100px;
        height: 260px;
      }

      &:hover {
        background: #d21d26;
        color: #ffffff;
        .qrcode-box {
          display: flex;
        }
        .hot-phone {
          display: flex;
        }
        .bg-serive {
          background-image: url('../../../assets/images/homePage/sidebar/service-hover.png');
        }
        .bg-top {
          background-image: url('../../../assets/images/homePage/sidebar/top-hover.png');
        }
        .bg-qrcode {
          background-image: url('../imgs/bg-qrcode-hover.png');
        }
        .bg-official {
          background-image: url('../imgs/setting-hover.png');
        }
        .bg-top {
          background-image: url('../../../assets/images/homePage/sidebar/top.png');
        }
        .bg-phone {
          background-image: url('../imgs/bg-phone-hover.png');
        }
        &::after {
          display: none;
        }
      }
    }
    li.serive-top {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #ffffff;
      cursor: pointer;
      margin-top: 8px;
      .top i {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .nav-title {
        font-size: 12px;
        font-weight: bold;
        color: #333333;
        line-height: 17px;
      }
    }

    li.bottom-line {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 38px;
        height: 1px;
        background: #eeeeee;
      }
    }
    .floor-item-nav {
      background: #ffffff;
      padding: 13px 5px;
      width: 100%;
      display: flex;
      justify-content: center;
      color: #333333;
      cursor: pointer;
      transition: color 0.2s ease-out;
      .floor-title {
        max-width: 36px;
        max-height: 36px;
        line-height: 18px;
        overflow: hidden;
        text-align: center;
        letter-spacing: 1px;
        padding-left: 0.5px;
        font-size: 12px;
        font-weight: bold;
      }
      &:hover {
        color: #ce2939;
      }
    }
    .floor-item-nav:nth-child(2) {
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.07);
      margin-bottom: 7px;
    }
    .floor-item-nav:nth-child(4) {
      margin-bottom: 7px;
    }
    .floor-item-nav:nth-child(2n -1) {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 38px;
        height: 1px;
        background: #eeeeee;
      }
    }
    .active-red {
      color: #d21d26;
    }
  }
}

@media screen and (max-width: 1300px) {
  .side-nav-container {
    ul.side-list .floor-item-nav {
      // display: none;
    }
  }
}
</style>
